<script>

export default {
    name: 'base',
    props: {
        environment: {
            type: Object,
            default: {}
        },
    },
    data () {
        return {
            showLoader : false,
            errorMessages : [],
            successMessage : '',
        };
    },
    computed : {
        userIsAdmin() {
            return this.environment.user_is_admin;
        },
        isDevServer() {
            return this.environment.is_dev_server;
        },
    },
}
</script>
